/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import FaxIcon from "@mui/icons-material/Fax";
import DoneIcon from "@mui/icons-material/Done";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import Insurance from "./Home/Insurance";
import { Link, useLocation } from "react-router-dom";
import left_side from "../assets/final-images/Resources/resource_big.jpg";
import abstruct from "../assets/final-images/shapes/abstract_4.png";
import { Helmet } from "react-helmet-async";

const Resources = () => {
  // const lenisRef = useLenis();
  // useEffect(() => {
  //   lenisRef?.current?.scrollTo(0); // top of the page
  // }, []);

  const { hash } = useLocation();

  useEffect(() => {
    // Function to attempt scrolling to the target element
    const scrollToHash = () => {
      if (hash) {
        const targetId = hash.replace("#", "");
        const element = document.getElementById(targetId);
        if (element) {
          // Calculate navbar height (adjust based on your navbar's actual height)
          const navbarHeight = 250; // Adjust this value as needed
          const elementPosition =
            element.getBoundingClientRect().top + window.pageYOffset;
          window.scrollTo({
            top: elementPosition - navbarHeight,
            behavior: "smooth",
          });
        } else {
          console.warn(`Element with ID ${targetId} not found`);
          // Scroll to top if hash is invalid
          window.scrollTo({ top: 0, behavior: "smooth" });
        }
      } else {
        // Scroll to top if no hash
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    };

    // Initial attempt
    scrollToHash();

    // Retry after a short delay to account for AOS or DOM rendering
    const timer = setTimeout(scrollToHash, 500);

    // Cleanup timer on unmount
    return () => clearTimeout(timer);
  }, [hash]);
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    }); // Scroll to the top when the component mounts
  }, []);
  return (
    <>
      <Helmet>
        <title>Medical Records Access | Citrus Diagnostic Center | Florida
</title>
        <meta
          name="description"
          content="Retrieve medical records, download diagnostic reports and manage personal health information through secure digital systems built for fast and organized access.
"
        />
        <meta
          name="keywords"
          content="medical records
Patient medical report 
Medical Record of Patient
radiology imaging records
Insurance and billings


"
        />
      </Helmet>
      <div className="flex justify-center flex-col items-center  md:pt-20 pt-14 xl:pt-48 text-[#ccc]">
        <h1 className="lg:text-[52px] text-[28px]  text-[#f5f5f5]  font-heading px-4 text-center capitalize ">
          Insurance & Billing
        </h1>
        <p className=" xl:mb-20 font-bold md:px-8 px-4 text-center">
          Clear information. No surprises
        </p>
        <div className="lg:w-[90%] w-[95%] mx-auto lg:pt-10 pt-8  ">
          <div className="bg-[#0f0f0f] justify-center items-center 2xl:px-24 xl:py-8 pb-10 xl:mt-16 mt-10   rounded-xl">
            <div className="   rounded-xl  2xl:px-14 xl:px-8 px-6 ">
              <div className=" lg:gap-20 gap-5 mt-6 grid lg:grid-cols-2">
                <div>
                  <p className="mt-6">
                    Citrus Diagnostic Center participates with many major
                    insurance plans. Coverage and benefits may vary depending on
                    your specific plan and the imaging service ordered.
                  </p>
                  <p className="mt-2">
                    We encourage patients to review their insurance coverage
                    prior to their appointment. Our team is available to assist
                    with general billing or insurance-related questions. For the
                    most accurate information regarding coverage, deductibles,
                    or co-payments, please contact your insurance provider
                    directly.
                  </p>
                </div>
                <div className="sm:ps-10">
                  <p className="mt-6 flex flex-row gap-3 items-center">
                    <span className="font-bold">
                      Billing Office : <LocalPhoneIcon />
                    </span>
                    <a href="tel:3524508062" className="pt-0.5 hover:underline">
                      (352) 450-8062
                    </a>
                  </p>
                  <p className="mt-6 flex flex-row gap-3 items-center">
                    <span className="font-bold">
                      Main Office : <LocalPhoneIcon />
                    </span>
                    <a href="tel:3527959200" className="pt-0.5 hover:underline">
                      (352) 795-9200
                    </a>
                  </p>
                  <p className="mt-6">Self-pay available at request.</p>
                </div>
              </div>
              <h2 className="lg:text-[38px] text-[24px] leading-[1.4em] text-[#f5f5f5] font-normal font-heading capitalize py-10  my-5 text-center ">
                Accepted Insurance Providers
              </h2>
            </div>

            <Insurance />
          </div>
          <div className=" w-full flex justify-center items-center overflow-hidden">
            <div className="flex justify-center items-center  lg:pt-16 md:pt-10  pb-10 xl:pb-5  w-full ">
              <img
                src={left_side}
                alt="mri outline"
                className="object-cover w-full rounded-xl "
              />{" "}
            </div>
          </div>
        </div>

        <div
          className="w-full mt-10"
          style={{
            background: `url(${abstruct}), #2e0504`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div
            id="medical-records"
            style={{
              background: "linear-gradient(#ffffff0d 0%, #ffffff14 100%)",
            }}
            className="lg:w-[90%] w-[95%] mx-auto   2xl:px-24 pt-4 pb-14  backdrop-blur-xl  xl:my-16  rounded-xl"
          >
            <div>
              <h2 className="lg:text-[38px] text-[24px] leading-[1.4em] text-[#f5f5f5] font-normal font-heading capitalize  mt-5 text-center ">
                {" "}
                Medical Records & Image Requests
              </h2>
              <p className=" lg:mb-20 mb-5 text-center ">
                {" "}
                Clear access. Simple requests. Secure delivery.
              </p>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-2 xl:gap-10 gap-8 lg:me-10">
              <div className="  rounded-xl  2xl:px-14 xl:px-8 px-6 ">
                <h3 className="lg:text-[28px] font-heading text-[20px] leading-[1.4em] text-[#cccccc] font-normal mt-6 ">
                  For Patients & Physicians
                </h3>

                <div className="mt-5">
                  <div className="w-full ">
                    <p className="">
                      To request access to medical records or imaging reports:
                    </p>{" "}
                    <ul className="  flex flex-col gap-2 pt-2.5 text-left font-robout">
                      <li className="flex items-start gap-2">
                        <KeyboardArrowRightIcon className="mt-[1px] text-[#bf9c5e]" />
                        Call our office to request access to your secure patient
                        or physician portal
                      </li>
                      <li className="flex items-start gap-2">
                        <KeyboardArrowRightIcon className="mt-[1px] text-[#bf9c5e]" />
                        Portal access allows you to view available reports and
                        information electronically
                      </li>
                    </ul>
                    <p className="mt-8 font-bold">
                      <Link
                        target="_blank"
                        to="https://citrusfl.abbadox.com/patientportal/login"
                        className="px-8 py-2.5 rounded-3xl bg-white text-black hover:bg-black hover:border hover:text-[#fff] border border-[#ffffff5d] transition-all duration-300"
                      >
                        Patient Login
                      </Link>
                    </p>
                  </div>

                  <div className="my-14">
                    <h3 className="lg:text-[28px] font-heading text-[20px] leading-[1.4em] text-[#cccccc] font-normal ">
                      For Healthcare Facilities
                    </h3>
                    <p className="mt-5">
                      Healthcare facilities requesting medical records or
                      imaging:
                    </p>
                    <ul className="  flex flex-col gap-2  pt-2.5 text-left font-robout">
                      <li className="flex items-start gap-2">
                        <KeyboardArrowRightIcon className="mt-[1px] text-[#bf9c5e]" />
                        Submit requests by fax and include an email address to
                        receive secure digital access via Clearpath
                      </li>
                      <li className="flex items-start gap-2">
                        <KeyboardArrowRightIcon className="mt-[1px] text-[#bf9c5e]" />
                        Or call our office to request Clearpath access and
                        provide an email address
                      </li>
                    </ul>
                    <p className="mt-2">
                      Clearpath enables secure electronic delivery of records
                      and images without physical media.
                    </p>
                    <p className="mt-2 font-bold">
                      <a
                        href="./Clearpath_Provider_Sharing.pdf"
                        download="Clearpath_Providers Flyer_Template.pdf"
                        className="underline hover:text-[#ffffff] transition-all duration-300"
                        onClick={() =>
                          window.open(
                            "./Clearpath_Provider_Sharing.pdf",
                            "_blank",
                          )
                        }
                      >
                        Clearpath_Providers Flyer_Template
                      </a>
                    </p>
                    <p className="mt-8 font-bold">
                      <Link
                        target="_blank"
                        to="https://platform.abbadox.com/idsauthenticationclient.ng/?appname=abbadox30.ng&acc=&redirectUrl=https://platform.abbadox.com/abbadoxng"
                        className="px-8 py-2.5 rounded-3xl bg-white text-black hover:bg-black hover:border hover:text-[#fff] border border-[#ffffff5d] transition-all duration-300"
                      >
                        Provider Login
                      </Link>
                    </p>
                  </div>
                  <h3 className="lg:text-[28px] font-heading text-[20px] leading-[1.4em] text-[#cccccc] font-normal mb-2 mt-10 ">
                    For Legal Requests
                  </h3>
                  <p className=" mt-5 ">
                    All legal requests for medical records or imaging are
                    fulfilled using Clearpath, our secure digital
                    release-of-information platform.
                  </p>

                  {/* <p className="mt-2">Everything in one place.</p> */}
                  <div className="mt-2">
                    <div className="w-full xl:pe-20">
                      <p className="">This enables:</p>
                      <ul className="  flex flex-col gap-2  pt-2.5  text-left font-robout">
                        <li className="flex items-start gap-2">
                          <DoneIcon className="mt-[1px] text-[#bf9c5e]" />
                          Secure electronic delivery
                        </li>
                        <li className="flex items-start gap-2">
                          <DoneIcon className="mt-[1px] text-[#bf9c5e]" />
                          Faster turnaround times
                        </li>
                        <li className="flex items-start gap-2">
                          <DoneIcon className="mt-[1px] text-[#bf9c5e]" />
                          Elimination of CDs, DVDs, or physical media
                        </li>
                      </ul>
                      <p className="mt-8 font-bold">
                        <Link
                          target="_blank"
                          to="https://prod.myclearpath.com/login"
                          className="px-8 py-2.5 rounded-3xl bg-white text-black hover:bg-black hover:border hover:text-[#fff] border border-[#ffffff5d] transition-all duration-300"
                        >
                          Legal Login
                        </Link>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="   xl:py-10 px-6 flex justify-center items-center">
                <div
                  style={{
                    background: `
              linear-gradient(90deg,
            #3d0e26 0%,
            #5a1f33 1%,
            #8b5e3c 40%,
            #8b5e3c 70%,
            #5a1f33 95%,
            #330a16 100%
          )
            `,
                  }}
                  className="xl:px-10 xl:py-16 p-8 xl:mt-0 mt-10 rounded-xl"
                >
                  <h3 className="lg:text-[24px] font-heading text-[18px] leading-[1.4em] text-[#cccccc] font-normal mb-2  ">
                    Questions or Assistance
                  </h3>
                  <p className=" mt-6 ">
                    If you are unsure which request method applies to you, our
                    team is available to help guide you through the process.
                  </p>
                  <p className="mt-3 flex flex-row gap-3 items-center">
                    <span className="font-bold">
                      <LocalPhoneIcon />
                    </span>
                    <a href="tel:3527959200" className="pt-0.5 hover:underline">
                      (352) 795-9200
                    </a>
                  </p>
                  <p className="mt-6 flex flex-row gap-3 items-center">
                    <span className="font-bold">
                      <FaxIcon />
                    </span>
                    <a href="tel:3524506460" className="pt-0.5 hover:underline">
                      (352) 795-6460
                    </a>
                  </p>

                  <p className="mt-3">
                    Contact our Clearpath support team at{" "}
                    <a
                      href="mailto:support@myclearpath.com"
                      className="font-semibold hover:underline"
                    >
                      support@myclearpath.com
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Resources;
